import * as React from "react";
import pureRender from "pure-render-deepcompare-decorator";
import * as classnames from "classnames";
import * as styles from "./NewUserTitle.scss";

export interface INewUserTitleProps{
    /**class */
    className?:string;
    signCount:number
}


@pureRender
export class NewUserTitle extends React.Component<INewUserTitleProps,any>{

   
    public render(){
        const {className} =this.props;
        const classNameSec=classnames(styles.sec,className);

       
        return (
            <div className={classNameSec}>
                <div className={styles.border_left}></div>
                <div className={styles.title_con} dangerouslySetInnerHTML={this.renderTitle()}> 
                   {/* {this.renderTitle()} */}
                </div>
                <div className={styles.border_right}></div>
                
            </div>
        )
    }

    private renderTitle=()=>{
        const {signCount} =this.props;
        return {
            __html:`<p>${window._CONFIG['TITLES']['day'+(signCount+1)]}</p>`
        };
    }
}

export default NewUserTitle;


// WEBPACK FOOTER //
// ./src/components/NewUserTitle/NewUserTitle.tsx